// @ts-nocheck

import memoize from 'memoize-state';
import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import { switchType as switchTypeAction } from '../actions/basket';
import GridsTypeTabs from '../components/basket/GridsTypeTabs';
import { GridTypes } from '../types';

const legacySelector = memoize((state) => {
  const { gridReference, gridType } = state.grids.basket;

  return {
    gridType,
    gridReference,
  };
});

type GridsTypeTabsContainerProps = {
  className?: string;
};

const GridsTypeTabsContainer = (ownProps: GridsTypeTabsContainerProps) => {
  const dispatch = useDispatch();

  const selectorProps = useSelector(legacySelector);

  const setPersonal = useCallback(() => {
    dispatch(switchTypeAction(GridTypes.PERSONAL));
  }, [dispatch]);

  const setTeam = useCallback(() => {
    dispatch(switchTypeAction(GridTypes.TEAM));
  }, [dispatch]);

  const otherProps = useMemo(() => ({ setPersonal, setTeam }), [setPersonal, setTeam]);

  const enhancedProps = useMergeProps({ ownProps, selectorProps, otherProps });

  return <GridsTypeTabs {...enhancedProps} />;
};

export default GridsTypeTabsContainer;
